export default {
  setRoutes(state, payload) {
    state.routes = payload;
  },
  updateRoute(state, payload) {
    if (state.routes) {
      const route = state.routes.find((x) => x.routeId === payload.routeId);
      route.routeName = payload.routeName;
      route.operators = payload.operators;
      route.areas = payload.areas;
      route.products = payload.products;
      route.sortedOrder = payload.sortedOrder;
      route.deletedContainers = payload.deletedContainers;
    }
  },
  addRoute(state, payload) {
    state.routes.push(payload);
  },
  setCurrentRoute(state, payload) {
    state.currentRoute = payload;
  },
  setFilteredSites(state, payload) {
    state.filteredSites = payload;
  },
  setResponseCode(state, payload) {
    state.responseCode = payload;
  },
  setRouteConfig(state, payload) {
    state.routeConfig = payload;
  },
};
